import React from 'react'

const DefenceProcurement = () => {
    return (
        <div>
            <h1>Defence Procurement</h1>
        </div>
    )
}

export default DefenceProcurement